import getApiHost from '../Utils/UrlUtils';

const API_URL = `${getApiHost()}`;

// eslint-disable-next-line import/prefer-default-export
export const LOGIN_URL = `${API_URL}/auth/token/`;
export const RESEND_CONFIRMATION_EMAIL_URL = `${API_URL}/resend-confirmation-email/`;
export const REQUEST_URL = `${API_URL}/users/me`;
export const REFRESH_URL = `${API_URL}/auth/token/refresh/`;
